<template>
<div>
  <a href="#" class="js-colorlib-nav-toggle colorlib-nav-toggle"><i></i></a>
  <aside id="colorlib-aside" role="complementary" class="js-fullheight img" style="background-image: url(images/slider-bg2.jpeg);">
    <h1 id="colorlib-logo" class="mb-2"><a href="/" style="font-size: 50px;">Anuchart</a></h1>
    <h1 id="colorlib-logo" class="mb-2"><a href="/" style="font-size: 50px;">Kongmalai</a></h1>
    <br><br>
    <nav id="colorlib-main-menu" role="navigation">
      <ul>
        <li class="colorlib"><a href="/">Home</a></li>
        <li class="colorlib p-2"><a href="/travel1"># เที่ยวแบบแปลก</a></li>
        <li class="colorlib p-2"><a href="/travel2"># ขับรถเที่ยวญี่ปุ่น</a></li>
      </ul>
    </nav>

    <div class="colorlib-footer">
      <p class="pfooter">
        <!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. -->
        Copyright &copy; 2020 All rights reserved | Made with <i class="icon-heart" aria-hidden="true"></i> by <a href="https://www.iyawat.com" target="_blank"> Iyawat Kongmalai </a>
        <!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. -->
      </p>
    </div>

  </aside> <!-- END COLORLIB-ASIDE -->
</div>
</template>

<script>
export default {
  name: 'NavBar',
  props: {
    msg: String
  }
}
</script>
